import React from 'react';
import {Link} from 'react-router-dom';
import {useFormContext, useWatch} from 'react-hook-form';
import Translate from '@src/components/Translate/Translate';
import getUri from '@src/helpers/getUri';

export default function ShowSameTypeProductsButton() {
    const {control} = useFormContext();
    const productId = useWatch({control, name: 'products.0.product_id'});
    const url = getUri({
        route: 'dashboards@production-by-product-id',
        params: {productId},
    });
    if (!productId || !url) {
        return null;
    }

    return <Link
            to={url}
            target="_blank"
            className="btn btn-outline-info"
    >
        <Translate message="OrderForm.products.same-type-production-link-label"/>
        <i className="fas fa-arrow-up-right-from-square ms-2"/>
    </Link>;
}
